<template>
    <div class="pt-2" style="padding: 10px;overflow: auto !important;">
        <v-row style="margin-left: 3px;">
            <v-col cols="4">
              <el-button v-if="operate.type == 2" type="primary" @click="saveData" style="margin-right: 5px;">保存</el-button>
              <el-popconfirm
                  v-if="operate.type == 2"
                  confirm-button-text='确定'
                  cancel-button-text='取消'
                  icon="el-icon-info"
                  icon-color="red"
                  @confirm="handleConfirm"
                  title="提交后不可再修改，请确认数据是否保存后再进行此操作！"
              >
                <el-button v-if="operate.type == 2"  type="primary" slot="reference">提交</el-button>
              </el-popconfirm>
              <el-button v-if="operate.type == 2" type="warning" @click="groupAudit" style="margin-left: 5px;">集团审批</el-button>
              <el-button type="info" @click="back" style="margin-left: 5px;">返回</el-button>
            </v-col>
        </v-row>

        <div>
            <div>
                <el-table
                        :data="tableData"
                        :span-method="objectSpanMethod"
                        border
                        style="width: 100%; margin-top: 20px;font-size: 17px;text-align: center;">
                    <el-table-column
                            prop="Id"
                            label="分类"
                            width="120">
                        <template slot-scope="scope">
                          {{ scope.row.category }}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="code"
                            label="编号">
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            label="项目名称"
                            width="180">
                    </el-table-column>
                    <el-table-column
                        prop="tm1Amount"
                        label="TM1合计"
                    ></el-table-column>
                    <el-table-column
                            prop="Total"
                            label="合计">
                        <template slot-scope="scope">
                            <div v-if="scope.row.code">
                                <span class="f-z17" style="margin-left: 10px;">
                                    {{ scope.row.total}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="January"
                            label="1月">
                        <template slot-scope="scope">
                            <div v-if="scope.row.code == 'G1' || scope.row.code == 'G2' || scope.row.code == 'G3'">
                                <span class="f-z17" style="margin-left: 10px">{{ scope.row.january }}</span>
                            </div>
                            <div v-else>
                                <v-text-field
                                        v-model="scope.row.january"
                                        @change="changeValue(scope.row, $event)"
                                        dense
                                        outlined
                                ></v-text-field>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="February"
                            label="2月">
                        <template slot-scope="scope">
                            <div v-if="scope.row.code == 'G1' || scope.row.code == 'G2' || scope.row.code == 'G3'">
                                <span class="f-z17" style="margin-left: 10px">{{ scope.row.february }}</span>
                            </div>
                            <div v-else>
                                <v-text-field
                                        v-model="scope.row.february"
                                        @change="changeValue(scope.row, $event)"
                                        dense
                                        outlined
                                ></v-text-field>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="March"
                            label="3月">
                        <template slot-scope="scope">
                            <div v-if="scope.row.code == 'G1' || scope.row.code == 'G2' || scope.row.code == 'G3'">
                                <span class="f-z17" style="margin-left: 10px">{{ scope.row.march }}</span>
                            </div>
                            <div v-else>
                                <v-text-field
                                        v-model="scope.row.march"
                                        @change="changeValue(scope.row, $event)"
                                        dense
                                        outlined
                                ></v-text-field>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="April"
                            label="4月">
                        <template slot-scope="scope">
                            <div v-if="scope.row.code == 'G1' || scope.row.code == 'G2' || scope.row.code == 'G3'">
                                <span class="f-z17" style="margin-left: 10px">{{ scope.row.april }}</span>
                            </div>
                            <div v-else>
                                <v-text-field
                                        v-model="scope.row.april"
                                        @change="changeValue(scope.row, $event)"
                                        dense
                                        outlined
                                ></v-text-field>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="May"
                            label="5月">
                        <template slot-scope="scope">
                            <div v-if="scope.row.code == 'G1' || scope.row.code == 'G2' || scope.row.code == 'G3'">
                                <span class="f-z17" style="margin-left: 10px">{{ scope.row.may }}</span>
                            </div>
                            <div v-else>
                                <v-text-field
                                        v-model="scope.row.may"
                                        @change="changeValue(scope.row, $event)"
                                        dense
                                        outlined
                                ></v-text-field>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="June"
                            label="6月">
                        <template slot-scope="scope">
                            <div v-if="scope.row.code == 'G1' || scope.row.code == 'G2' || scope.row.code == 'G3'">
                                <span class="f-z17" style="margin-left: 10px">{{ scope.row.june }}</span>
                            </div>
                            <div v-else>
                                <v-text-field
                                        v-model="scope.row.june"
                                        @change="changeValue(scope.row, $event)"
                                        dense
                                        outlined
                                ></v-text-field>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="July"
                            label="7月">
                        <template slot-scope="scope">
                            <div v-if="scope.row.code == 'G1' || scope.row.code == 'G2' || scope.row.code == 'G3'">
                                <span class="f-z17" style="margin-left: 10px">{{ scope.row.july }}</span>
                            </div>
                            <div v-else>
                                <v-text-field
                                        v-model="scope.row.july"
                                        @change="changeValue(scope.row, $event)"
                                        dense
                                        outlined
                                ></v-text-field>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="August"
                            label="8月">
                        <template slot-scope="scope">
                            <div v-if="scope.row.code == 'G1' || scope.row.code == 'G2' || scope.row.code == 'G3'">
                                <span class="f-z17" style="margin-left: 10px">{{ scope.row.august }}</span>
                            </div>
                            <div v-else>
                                <v-text-field
                                        v-model="scope.row.august"
                                        @change="changeValue(scope.row, $event)"
                                        dense
                                        outlined
                                ></v-text-field>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="September"
                            label="9月">
                        <template slot-scope="scope">
                            <div v-if="scope.row.code == 'G1' || scope.row.code == 'G2' || scope.row.code == 'G3'">
                                <span class="f-z17" style="margin-left: 10px">{{ scope.row.september }}</span>
                            </div>
                            <div v-else>
                                <v-text-field
                                        v-model="scope.row.september"
                                        @change="changeValue(scope.row, $event)"
                                        dense
                                        outlined
                                ></v-text-field>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="October"
                            label="10月">
                        <template slot-scope="scope">
                            <div v-if="scope.row.code == 'G1' || scope.row.code == 'G2' || scope.row.code == 'G3'">
                                <span class="f-z17" style="margin-left: 10px">{{ scope.row.october }}</span>
                            </div>
                            <div v-else>
                                <v-text-field
                                        v-model="scope.row.october"
                                        @change="changeValue(scope.row, $event)"
                                        dense
                                        outlined
                                ></v-text-field>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="November"
                            label="11月">
                        <template slot-scope="scope">
                            <div v-if="scope.row.code == 'G1' || scope.row.code == 'G2' || scope.row.code == 'G3'">
                                <span class="f-z17" style="margin-left: 10px">{{ scope.row.november }}</span>
                            </div>
                            <div v-else>
                                <v-text-field
                                        v-model="scope.row.november"
                                        @change="changeValue(scope.row, $event)"
                                        dense
                                        outlined
                                ></v-text-field>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="December"
                            label="12月">
                        <template slot-scope="scope">
                            <div v-if="scope.row.code == 'G1' || scope.row.code == 'G2' || scope.row.code == 'G3'">
                                <span class="f-z17" style="margin-left: 10px">{{ scope.row.december }}</span>
                            </div>
                            <div v-else>
                                <v-text-field
                                        v-model="scope.row.december"
                                        @change="changeValue(scope.row, $event)"
                                        dense
                                        outlined
                                ></v-text-field>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

      <!--导入弹窗-->
      <v-dialog v-model="auditDialog" width="600">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"
          >{{ title }}</v-card-title
          >
          <v-card-text>
            <v-container>
              <v-radio-group
                  v-model="auditStatus"
                  row
              >
                <v-radio
                    label="审批通过"
                    value="1"
                ></v-radio>
                <v-radio
                    label="审批不通过"
                    value="2"
                ></v-radio>
              </v-radio-group>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="primary" text @click="sureAudit"> 确认 </v-btn>
            <v-btn text @click="hideAudit"> 取消 </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>
    import {default as CwBudgetCost} from "@/api/pd/budget/CwBudgetCostApi.js";
    export default {
        props: {
            page: {
                type: Object,
                default: null,
            },
            item: {
                type: Object,
                default: null
            },
            operate: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                title: '',
                currentAudit: 0,
                auditDialog: false,
                tableData: [],
                auditStatus: 0,
                t1: ['工程维保费', '工程维修费', '电费', '水费', '供暖费'],
                t2: ['物料用品费', '运杂费', '邮电费', '办公费', '劳动保护费']
            }
        },
        created() {
            // this.getDataApi()
            console.log(this.operate)
            this.getDataFromApi()
        },
        watch: {
            tableData: {
                handler(newVal, oldVal) {
                  newVal.map(item => {
                    item.total = (parseFloat(item.january)
                        + parseFloat(item.february)
                        + parseFloat(item.march) + parseFloat(item.april)
                        + parseFloat(item.may) + parseFloat(item.june)
                        + parseFloat(item.july) + parseFloat(item.august)
                        + parseFloat(item.september) + parseFloat(item.october)
                        + parseFloat(item.november) + parseFloat(item.december)).toFixed(2)
                  })
                },
                deep: true
            }
        },
        methods: {
            hideAudit() {
              this.title = ''
              this.currentAudit = 0
              this.auditDialog = false
            },
            changeValue(item, val) {
                console.log(item, val);
            },
            getDataFromApi() {
                let that = this
                let query= {costId: this.item.id, storeName: this.item.mdmc, year: this.item.year};
                CwBudgetCost.projectDetail(query).then(resp=>{
                    console.log(resp);
                    that.tableData = resp.data.data.rows;
                    that.tableData.map(item => {
                      if (item.tm1Amount == null) {
                        item.tm1Amount = 0.00
                      }
                      item.tm1Amount = item.tm1Amount.toFixed(2)
                    })
                });
            },
            back(){
                this.$emit("back", {formStatus:'list'})
            },
            // 获取初始数据
            getDataApi() {
                let arr = []
                for (let i = 0; i < 2; i++) {
                    let id = i == 1 ? '费用化' : '工程'
                    let arrNew = {}
                    for (let j = 0; j < 5; j++) {
                        let num = i== 0 ? parseInt(j) + 1 : parseInt(j) + 6
                        arrNew = {
                            Id: id,
                            Name: 'G' + num,
                            ProjectName: this.t1[j],
                            Total: '',
                            January: '',
                            February: '',
                            March: '',
                            April: '',
                            May: '',
                            June: '',
                            July: '',
                            August: '',
                            September: '',
                            October: '',
                            November: '',
                            December: '',
                            is_disable: i == 0 && (j == 0 || j == 1) ? 1 : 0
                        }

                        arr.push(arrNew)
                    }
                }

                this.tableData = arr
            },
            arraySpanMethod({ row, column, rowIndex, columnIndex }) {
                if (rowIndex % 5 === 0) {
                    if (columnIndex === 0) {
                        return [1, 2, 3, 4, 5];
                    } else if (columnIndex === 1) {
                        return [0, 0];
                    }
                }
            },

            objectSpanMethod({ row, column, rowIndex, columnIndex }) {
                if (columnIndex === 0) {
                    if (rowIndex % 5 === 0) {
                        return {
                            rowspan: 5,
                            colspan: 1
                        };
                    } else {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    }
                }
            },
            // 保存
            saveData(flag = 0) {
                let that = this;
                if (this.item.status == 1 || this.item.status == 5) {
                  let data = this.tableData
                  let arr = []
                  data.map(item => {
                    if (item.code != 'G1' || item.code != 'G2' || item.code != 'G3') {
                      // 1月
                      if (item.january != '' && item.january != null) {
                        arr.push({
                          costId: that.item.id,
                          matterId: item.id,
                          month: 1,
                          budgetFee: parseFloat(item.january)
                        })
                      }
                      // 2月
                      if (item.february != '' && item.february != null) {
                        arr.push({
                          costId: that.item.id,
                          matterId: item.id,
                          month: 2,
                          budgetFee: parseFloat(item.february)
                        })
                      }
                      // 三月
                      if (item.march != '' && item.march != null) {
                        arr.push({
                          costId: that.item.id,
                          matterId: item.id,
                          month: 3,
                          budgetFee: parseFloat(item.march)
                        })
                      }
                      // 4月
                      if (item.april != '' && item.april != null) {
                        arr.push({
                          costId: that.item.id,
                          matterId: item.id,
                          month: 4,
                          budgetFee: parseFloat(item.april)
                        })
                      }
                      // 5月
                      if (item.may != '' && item.may != null) {
                        arr.push({
                          costId: that.item.id,
                          matterId: item.id,
                          month: 5,
                          budgetFee: parseFloat(item.may)
                        })
                      }
                      // 6月
                      if (item.june != '' && item.june != null) {
                        arr.push({
                          costId: that.item.id,
                          matterId: item.id,
                          month: 6,
                          budgetFee: parseFloat(item.june)
                        })
                      }
                      // 7月
                      if (item.july != '' && item.july != null) {
                        arr.push({
                          costId: that.item.id,
                          matterId: item.id,
                          month: 7,
                          budgetFee: parseFloat(item.july)
                        })
                      }
                      // 8月
                      if (item.august != '' && item.august != null) {
                        arr.push({
                          costId: that.item.id,
                          matterId: item.id,
                          month: 8,
                          budgetFee: parseFloat(item.august)
                        })
                      }
                      // 9月
                      if (item.september != '' && item.september != null) {
                        arr.push({
                          costId: that.item.id,
                          matterId: item.id,
                          month: 9,
                          budgetFee: parseFloat(item.september)
                        })
                      }
                      // 10月
                      if (item.october != '' && item.october != null) {
                        arr.push({
                          costId: that.item.id,
                          matterId: item.id,
                          month: 10,
                          budgetFee: parseFloat(item.october)
                        })
                      }
                      // 11月
                      if (item.november != '' && item.november != null) {
                        arr.push({
                          costId: that.item.id,
                          matterId: item.id,
                          month: 11,
                          budgetFee: parseFloat(item.november)
                        })
                      }
                      // 12月
                      if (item.december != '' && item.december != null) {
                        arr.push({
                          costId: that.item.id,
                          matterId: item.id,
                          month: 12,
                          budgetFee: parseFloat(item.december)
                        })
                      }
                    }
                  })
                  let params = {
                    dataList: arr,
                    costId: that.item.id
                  }
                  CwBudgetCost.saveData(params).then(res => {
                    console.log(res);
                    res = res.data
                    if (res.code == 200) {
                      if (flag != 1) {
                        alert('数据保存成功!')
                      }
                      that.getDataFromApi()
                    } else {
                      alert(res.msg)
                    }
                  }).catch(error => {
                    console.log(error)
                    alert('网络错误，请稍后重试')
                  })
                } else {
                  alert("当前状态不可进行此操作")
                  return false
                }
            },
            // 提交
            handleConfirm() {
		          this.saveData(1)
              if (this.item.status == 1 || this.item.status == 5) {
                let param = {
                  costId: this.item.id
                }
                // 判断数据是否对得上 tm1 和 合计数据
                console.log(this.tableData)
                let num = 0
                let msg = ''
                this.tableData.map(item => {
                  if (parseFloat(item.tm1Amount).toFixed(2) != parseFloat(item.total).toFixed(2)) {
                    num++;
                    msg += item.code + ' '
                  }
                })
                if (num > 0) {
                  alert(msg + 'tm1金额 和 合计金额不一致 无法提交; 修改数据后，先保存再提交!')
                  return false
                }
                CwBudgetCost.submitBudget(param).then(res => {
                  console.log(res)
                  res = res.data
                  if (res.code == 200) {
                    alert('提交成功！')
                    that.item.status = 2
                  } else {
                    alert(res.msg)
                  }
                }).catch(error => {
                  console.log(error)
                  alert('网络错误，请稍后重试')
                })
              } else {
                alert("当前状态不可进行此操作")
                return false
              }
              let that = this
              let param = {
                costId: this.item.id
              }

            },
            // 财务审批
            financeAudit() {
              if (this.item.status != 3) {
                alert("当前状态不可进行此操作")
                return false
              }
              this.auditDialog = true
              this.title = '财务审批'
              this.currentAudit = 2

            },
            // 集团审批
            groupAudit() {
              if (this.item.status != 2) {
                alert("当前状态不可进行此操作")
                return false
              }
              this.auditDialog = true
              this.title = '集团审批'
              this.currentAudit = 1
            },
            // 审批- 确认
            sureAudit() {
              let that = this
              let params = {
                costId: this.item.id,
                status: this.auditStatus
              }
              if (this.currentAudit == 1) {
                CwBudgetCost.groupAuditBudget(params).then(res => {
                  console.log(res)
                  res = res.data
                  if (res.code == 200) {
                    alert(res.msg)
                    that.item.status = that.auditStatus == 1 ? 3 : 5
                    that.auditDialog = false
                    that.auditStatus = 0
                  } else {
                    alert(res.msg)
                  }
                }).catch(error => {
                  console.log(error)
                  alert('网络错误，请稍后重试')
                })
              } else {
                CwBudgetCost.financeAuditBudget(params).then(res => {
                  console.log(res)
                  res = res.data
                  if (res.code == 200) {
                    alert(res.msg)
                    that.item.status = that.auditStatus == 1 ? 4 : 5
                    that.auditDialog = false
                    that.auditStatus = 0
                  } else {
                    alert(res.msg)
                  }
                }).catch(error => {
                  console.log(error)
                  alert('网络错误，请稍后重试')
                })
              }
            }
        }
    }
</script>

<style scoped>
  .f-z17 {
    font-size: 14px !important;
  }
</style>